import React from 'react';
import { useSelector } from 'react-redux';
import MobileNav from './MobileNav';
import GuestFooter from './GuestFooter';

// Logged-in users get the same persistent quick-nav bar as the rest of the app; guests get the legal footer.
const SiteFooter = () => {
    const { token } = useSelector((state) => state.auth);
    return token ? <MobileNav /> : <GuestFooter />;
};

export default SiteFooter;
